/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_Error_FetchInputs */

const en_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to fetch regional comparison.`)
};

const de_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regionaler Vergleich konnte nicht abgerufen werden.`)
};

const fr_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de récupérer la comparaison régionale.`)
};

const es_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo obtener la comparación regional.`)
};

const it_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero del confronto regionale non riuscito.`)
};

const nl_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regionale vergelijking ophalen mislukt.`)
};

const pl_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się pobrać porównania regionalnego.`)
};

const fi_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aluevertailun hakeminen epäonnistui.`)
};

const da_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke hente regional sammenligning.`)
};

const sv_salary_compare_error_fetch = /** @type {(inputs: Salary_Compare_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte hämta regional jämförelse.`)
};

/**
* | output |
* | --- |
* | "Failed to fetch regional comparison." |
*
* @param {Salary_Compare_Error_FetchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_error_fetch = /** @type {((inputs?: Salary_Compare_Error_FetchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_Error_FetchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_error_fetch(inputs)
	if (locale === "fr") return fr_salary_compare_error_fetch(inputs)
	if (locale === "es") return es_salary_compare_error_fetch(inputs)
	if (locale === "it") return it_salary_compare_error_fetch(inputs)
	if (locale === "nl") return nl_salary_compare_error_fetch(inputs)
	if (locale === "pl") return pl_salary_compare_error_fetch(inputs)
	if (locale === "fi") return fi_salary_compare_error_fetch(inputs)
	if (locale === "da") return da_salary_compare_error_fetch(inputs)
	if (locale === "sv") return sv_salary_compare_error_fetch(inputs)
	return en_salary_compare_error_fetch(inputs)
});